import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["input"];

  checkNC(event) {
    this.handleAutoCheck(event.currentTarget);
    const values = this.inputTargets
      .filter((input) => input.checked)
      .map((input) => input.value);
    this.stimulate("Handlers#save_measure", event.currentTarget, {
      values: values,
    });
  }

  handleAutoCheck(element) {
    const ncInput = this.inputTargets.find(
      (input) => input.value === "NC" && input.checked
    );
    if (element === ncInput) {
      this.inputTargets.forEach((input) => (input.checked = false));
      element.checked = !element.checked;
    } else if (["EU", "EE"].includes(element.value) && ncInput) {
      ncInput.checked = false;
    }
  }
}
